<div class="row mt-2">
  <div class="form-group col-md-3">
    <label for="tipo_medicamento">Tipo<span class="text-danger">*</span></label>
    <select [compareWith]="compareFn" id="tipo_medicamento" [(ngModel)]="entidade.medicamento.tipo_medicamento"
      [ngModelOptions]="{standalone: true}" class="form-control">
      <option [ngValue]="undefined">Selecione o Tipo</option>
      <option value="N">Não Controlado</option>
      <option value="A">Tipo A</option>
      <option value="B">Tipo B</option>
      <option value="C">Tipo C</option>
    </select>
  </div>
  <div class="form-group col-md-6">
    <label for="classificacao">Classificação terapêutica<span class="text-danger">*</span></label>
    <input id="classificacao" [(ngModel)]="entidade.medicamento.classificacao" [ngModelOptions]="{standalone: true}"
      type="text" class="form-control">
  </div>
</div>

<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" #btnAdicionarConcentracao class="btn btn-sm btn-primary">
      <i class="fa fa-plus"></i> Adicionar Concentração
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <table class="table table-sm table-eddy">
      <thead>
        <tr>
          <th scope="col">Peso Inicial</th>
          <th scope="col">Peso Final</th>
          <th scope="col">Idade Inicial</th>
          <th scope="col">Idade Final</th>
          <th scope="col">Dose Diária</th>
          <th style="width: 120px" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of entidade.medicamento?.concentracoes; let idx = index">
          <td>
            <span *ngIf="!item.editavel">{{item.peso_inicial}}</span>
            <input *ngIf="item.editavel" [(ngModel)]="item.peso_inicial" [ngModelOptions]="{standalone: true}"
              type="text" class="form-control">
          </td>
          <td>
            <span *ngIf="!item.editavel">{{item.peso_final}}</span>
            <input *ngIf="item.editavel" [(ngModel)]="item.peso_final" [ngModelOptions]="{standalone: true}" type="text"
              class="form-control">
          </td>
          <td>
            <span *ngIf="!item.editavel">{{item.idade_inicial}}</span>
            <input *ngIf="item.editavel" [(ngModel)]="item.idade_inicial" [ngModelOptions]="{standalone: true}"
              type="text" class="form-control">
          </td>
          <td>
            <span *ngIf="!item.editavel">{{item.idade_inicial}}</span>
            <input *ngIf="item.editavel" [(ngModel)]="item.idade_inicial" [ngModelOptions]="{standalone: true}"
              type="text" class="form-control">
          </td>
          <td>
            <span *ngIf="!item.editavel">{{item.dose_diaria}}</span>
            <input *ngIf="item.editavel" [(ngModel)]="item.dose_diaria" [ngModelOptions]="{standalone: true}"
              type="text" class="form-control">
          </td>

          <td class="text-right">
            <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
              <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
            </button>
            <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
            </button>
            <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
              <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
            </button>
            <button *ngIf="!item.editavel" (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionarInteracao()" #btnAdicionarInteracao class="btn btn-sm btn-primary">
      <i class="fa fa-plus"></i> Adicionar Interação Medicamentosa
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <table class="table table-sm table-eddy">
      <thead>
        <tr>
          <th scope="col">Produto</th>
          <th style="width: 120px" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of entidade.medicamento?.interacoes_medicamentosas; let idx = index">
          <td>
            <span *ngIf="!item.editavel">{{item.codigo}} {{item.nome}}</span>
            <p-autoComplete *ngIf="item.editavel" [(ngModel)]="interacaoAtual" [forceSelection]="true"
              [autoHighlight]="true" [ngModelOptions]="{standalone: true}" [field]="produtoAutoComplete.conversor"
              [suggestions]="produtoAutoComplete.lista" (completeMethod)="produtoAutoComplete.filtrar($event)"
              inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }">
              <ng-template let-produto pTemplate="item">
                {{produto.codigo}} {{produto.nome}}
              </ng-template>
            </p-autoComplete>
          </td>

          <td class="text-right">
            <button *ngIf="item.editavel" (click)="salvarInteracao(item)" class="btn btn-sm btn-outline-secondary mr-2">
              <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
            </button>
            <button *ngIf="item.editavel" (click)="cancelarInteracao(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
            </button>
            <button *ngIf="!item.editavel" (click)="editarInteracao(item)" class="btn btn-sm btn-outline-primary mr-2">
              <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
            </button>
            <button *ngIf="!item.editavel" (click)="removerInteracao(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>